<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <!-- ================= DESKTOP (keeps background card) ================= -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white">
            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>

          <div class="card-body  my-3 bg-white  rounded-5">
            <h5 class="fw-500 mb-3"> RSVP Confirmations</h5>
            <div class="row g-2 mb-3">
              <div
                v-for="card in rsvp_dashboard_cards"
                :key="card.label"
                class="col-6 col-md-4 col-xl"
              >
                <div class="dashboard-summary-card border rounded bg-white p-3 h-100 shadow-sm">
                  <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                    <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                      <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                      <div class="fw-bold text-dark h5 mb-0 mt-2">{{ card.value }}</div>
                    </div>
                    <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                      <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <button @click="exportToCSV" class="btn btn-primary btn-sm text-xxs  mb-2">Export to CSV</button>
            <div class=" table-responsive data-table">
              <table v-if="cbo_domain" id="table" class="table align-middle table-striped table-borderless mb-0 ">
                <thead class="text-uppercase btn-primary text-white sticky-top">
                  <tr>
                  <th class="text-center">#</th>
                  <th class="text-center">First Name</th>
                  <th class="text-center">Last Name</th>
                  <th class="text-center">Email</th>
                  <th  class="text-center">Business Name</th>
                  <th  class="text-center">First Time Attending?</th>
                  <th class="text-center">Chapter</th>
                  <th class="text-center">Phone Number</th>
                  <th class="text-center">Event Name</th>
                  <th class="text-center">Menu Item</th>
                  <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody class="text-xxs">
                  <tr v-for="(member, index) in members" :key="member.id" class="border-bottom">
                    <td class="text-center">
                      <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 small">
                        {{ index + 1 }}
                      </span>
                    </td>
                    <td>{{ member?.user?.first_name }}</td>
                    <td>{{ member?.user?.last_name }}</td>
                    <td>{{ member?.user?.email }}</td>
                    <td>{{ member?.business_name || "None" }}</td>
                    <td class="text-center">
                      <span class="chip chip-secondary">{{ member.is_first_time ? 'Yes' : 'No' }}</span>
                    </td>
                    <td class="text-center">{{ member?.chapter || "None" }}</td>
                    <td class="text-center">{{ member?.user?.phone_number }}</td>
                    <td class="text-center">{{ member?.event_name }}</td>
                    <td class="text-center">
                      <span v-if="member.rsvp_items && member.rsvp_items.length > 0" class="text-xxs">
                        <span v-for="(item, idx) in member.rsvp_items" :key="item.id">
                          {{ item.item?.item_name }}<span v-if="idx !== member.rsvp_items.length - 1">, </span>
                        </span>
                      </span>
                      <span class="text-xxs" v-else>No Items</span>
                    </td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center gap-1">
                        <button
                          class="btn btn-light btn-sm rounded-3 text-danger border text-xxs"
                          @click="cancelRSVP(member.event_id, member.user.id)"
                        >
                          Cancel RSVP
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table v-else class="table align-middle table-striped table-borderless mb-0">
                <thead class="text-uppercase small btn-primary text-white sticky-top text-xxs">
                  <tr>
                    <th class="text-center">#</th>
                    <th class="text-center">First Name</th>
                    <th class="text-center">Last Name</th>
                    <th class="text-center">Email</th>
                    <th class="text-center">Phone Number</th>
                    <th class="text-center">Event Name</th>
                    <th class="text-center">Menu Item</th>
                    <th class="text-center">Action</th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(member, index) in members" :key="member.id" class="border-bottom text-xxs">
                    <td class="text-center">
                      <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 small">
                        {{ index + 1 }}
                      </span>
                    </td>
                    <td class="text-center">{{ member?.user?.first_name }}</td>
                    <td class="text-center">{{ member?.user?.last_name }}</td>
                    <td class="text-center">{{ member?.user?.email }}</td>
                    <td class="text-center">{{ member?.user?.phone_number }}</td>
                    <td class="text-center">{{ member?.event_name }}</td>
                    <td class="text-center">
                      <span v-if="member.rsvp_items && member.rsvp_items.length > 0">
                        <span v-for="(item, idx) in member.rsvp_items" :key="item.id">
                          {{ item.item?.item_name }}<span v-if="idx !== member.rsvp_items.length - 1">, </span>
                        </span>
                      </span>
                      <span v-else>No Items</span>
                    </td>
                    <td class="text-center">
                      <div class="d-flex justify-content-center gap-1">
                        <button
                          class="btn btn-light btn-sm rounded-3 text-danger border text-xxs"
                          @click="cancelRSVP(member.event_id, member.user.id)"
                        >
                          Cancel RSVP
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>
          </div>
        </div>

      </div>

    </div> <!-- /row -->
  </div> <!-- /container-fluid -->

</div>


    <div class="modal fade" id="verifyRsvpModal" tabindex="-1" aria-labelledby="verifyRsvpModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content border rounded-5 shadow">
          <div class="modal-header bg-dark-purple text-white">
            <h5 class="modal-title" id="verifyRsvpModalLabel">Verify RSVP Code</h5>
            <button type="button" class="btn-close text bg-white" data-bs-dismiss="modal" aria-label="Close" @click="resetForm"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="verifyRsvpCode" class="text-center">
              <h3 class="fw-bold">RSVP Verification</h3>
              <p class="text-muted">Please enter your RSVP code</p>

              <div class="input-group mb-3">
                <input 
                  type="text" 
                  id="rsvpCode" 
                  v-model="rsvp_code" 
                  class="form-control text-center" 
                >
                <span class="input-group-text bg-success text-white" v-if="isVerified">
                  ✔
                </span>
              </div>

              <!-- Message Box -->
              <div v-if="message && !isVerified" class="alert text-center mt-2 alert-danger">
                {{ message }}
            </div>
            <div v-if="isVerified" class="alert text-center mt-2 alert-success">
                <div class="text-start">
                    <p>Event: {{ verifiedMember.event.event_name }}</p>
                    <p>Guest: {{ verifiedMember.user.first_name }} {{ verifiedMember.user.last_name }}</p>
                </div>
            </div>

              <button type="submit" class="btn btn-dark  mt-3 fw-bold">Verify Code</button>
            </form>
          </div>

        </div>
      </div>
    </div>
